<template>
  <div class="right">
    <div class="r-title yd-display-flex yd-alignItems">
      <i></i>
      <span>热点动态</span>
    </div>
    <div class="side-info">
      <div
        @click="dynamicDetail(item)"
        v-for="(item, index) in listData"
        :key="index"
        class="info-item yd-display-flex"
      >
        <img
          class="blue-arrow"
          src="../../../assets/images/blueArrowRightIcon.png"
        />
        <div class="r">
          <h3 v-text="item.title"></h3>
          <p class="yd-clamp-1" v-text="item.contentText"></p>
          <span v-text="item.date"></span>
        </div>
      </div>
      <p v-if="listData.length === 0" class="no-data-tip-text">
        暂无最新的热点动态
      </p>
    </div>
  </div>
</template>

<script>
import { getDynamicNews } from "@/api/common";
export default {
  name: "rightNavbar",
  data() {
    return {
      listData: [],
    };
  },
  mounted() {
    getDynamicNews({
      pageIndex: 1,
      pageSize: 5,
      status: 1,
      type: -1,
      hot_spot: 1,
    }).then((res) => {
      res.data.data.records.forEach((item) => {
        let contentHtml = $(item.articleContent);
        item.contentText = contentHtml.text();
        item.date = item.createTime.split(" ")[0];
      });
      this.listData = res.data.data.records;
    });
  },
  methods: {
    // 详情
    dynamicDetail(item) {
      this.$root.Bus.$emit("topNavbarArea", "热点动态");
      this.$router.push({
        path: "/mould/aboutSr/news/newsDetails",
        query: { id: item.id },
      });
      this.$root.Bus.$emit("aboutSr-pageCustomi-details-event");
    },
  },
};
</script>

<style scoped>
.right {
  width: 340px;
  overflow: hidden;
}
.right .r-title {
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
  margin: 32px 0 0 0;
  box-sizing: border-box;
  padding: 6px;
  font-size: 16px;
  font-weight: 400;
}
.right .r-title i {
  display: inline-block;
  width: 4px;
  height: 20px;
  background: #2e81e1;
  margin-right: 5px;
}
.right .side-info {
  box-sizing: border-box;
  padding: 18px 0;
}
.right .side-info .info-item {
  margin: 0 0 12px 0;
  cursor: pointer;
}
.info-item .blue-arrow {
  width: 15px;
  height: 15px;
  margin-right: 4px;
  position: relative;
  top: 2px;
  margin-left: 8px;
}
.info-item .r {
  overflow: hidden;
}
.info-item .r:hover h3,
.info-item .r:hover p,
.info-item .r:hover span {
  color: #2e81e1;
}
.info-item .r h3 {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  margin: 0 0 10px 0;
  line-height: 20px;
}
.info-item .r p {
  color: #999999;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 6px;
}
.info-item .r span {
  font-size: 12px;
  color: #666666;
  line-height: 16px;
}
.no-data-tip-text {
  text-align: center;
  color: #dedede;
  margin-top: 20px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutSr/components/rightNavbar.vue